import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Container, Row, Col, Button, Card, CardBody } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import ServerTable from "../../../lib/ServerTable";
import DateRangePicker from "../../../lib/DateRangePicker";
import getVehicleColums from "./columns/VehicleColumns";
import { useAuth, useApiDelete } from "../../../hooks";
import { ConfirmModal, SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import filterIcon from "../../../common/images/filter.png";

import "../../../common/css/DateRangePicker.css";

const formInitailData = {
    userStatus: null,
  };

export default function Vehicle() {

  const navigate = useNavigate();

  const roleKey = localStorage.getItem("roleKey");
  const entityId = localStorage.getItem("entityId");
  if(roleKey === 'bunk_incharge' && entityId == "") {
      navigate('/');
  }

  let searchObjIntl = '';
  if(roleKey === 'bunk_incharge') {
    let filterTxt = 'entityId|'+entityId;   
        searchObjIntl = {filter:filterTxt};
  }
  const [formData, setFormData] = useState(formInitailData);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showFilder, setShowFilder] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [customSearch, setCustomSearch] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [searchObjVal, setSearchObjVal] = useState(searchObjIntl);
  const [customerror, setCustomerror] = useState('');
  const [selectedDateRange, setSelectedDateRange] = useState({startDate: '',endDate: ''});
  const [tableKey, setTableKey] = useState(0);


    useEffect(() => {
      const searchObj = {};
      let filterTxt = '';
      if(roleKey === 'bunk_incharge') {
          filterTxt = 'entityId|'+entityId;
      }
      if(selectedDateRange?.startDate !== undefined && selectedDateRange?.startDate != "" && selectedDateRange?.startDate != null && selectedDateRange?.endDate !== undefined && selectedDateRange?.endDate != "" && selectedDateRange?.endDate != null) {
        let startDateTxt = selectedDateRange?.startDate+' 00:00:00';
        let endDateTxt = selectedDateRange?.endDate+' 23:59:59';
        let dateRngTxt = 'startTime|'+startDateTxt+'&endTime|'+endDateTxt;
        filterTxt = (filterTxt)?filterTxt+'&'+dateRngTxt:dateRngTxt;
      }

      if(filterTxt != "") {
        searchObj.filter = filterTxt;
      }

      setSearchObjVal(searchObj);
      setTableKey(prev => prev + 1);
  }, [
    selectedDateRange?.startDate,
    selectedDateRange?.endDate
  ]);

  const handleDateRangeApply = (dateRange) => {
    console.log('Received dates:', dateRange);
    setSelectedDateRange(dateRange);
  };
   
  const handleDelete = (roleId) => {
        setShowConfirm(true);
        setSelectedRowId(roleId);
  };

  const handleViewDetail = (rowDetails) => {
        /*setRowData(rowDetails);
        setShowDetails(true);*/
        localStorage.setItem('view_details', JSON.stringify(rowDetails, null, 2));
        navigate('/vehicle/detail');
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const handleSearchChange = (e) => {
    setCustomSearch(e.target.value);
  };


  const columns = getVehicleColums('list', handleDelete, handleViewDetail);

  const handleChange = (selectedOption, actionMeta) => {
    setFormData(prev => ({
      ...prev,
      [actionMeta.name]: selectedOption
    }));
  };

  const userStatusOptions = [
    { value: "", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const subscriptionStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "expired", label: "Expired" },
    { value: "pending", label: "Pending" },
    { value: "merged", label: "Merged" },
  ];

  return (<div className="vehicle-management-page">
          <Container fluid>
            <div className='page-title-main'>
              <h5 className='page-title'>Vehicle Management</h5>
              <p className='page-info'>Track vehicle movement and fuel usage across all petrol bunks.</p>
            </div> 
            <div className='page-content-main'>
              {isDeleted && <SuccessToolbar message="🎉 Role have been deleted successfully." />}
              {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
              
              <div className='filter-action-main'>
                    <Row className="mb-2">
                        <Col xs={12} sm={6} md={9}>
                            <div className='input-filter-action'>
                                <input type="text" id="customSearch" name='customSearch' placeholder="Search by vehicle number & vehicle type" value={customSearch} onChange={handleSearchChange} />
                            </div>
                        </Col>
                        {/*<Col xs={4} sm={1} md={1} className='select-filter-actiontopdiv apply-mgtp-mbl'>
                            <div className='select-filter-action'>
                                <div className='select-filter-btn' onClick={() => setShowFilder(true)} ><span className='select-filter-txt'>Filter</span><span className='select-filter-icon'><img src={filterIcon} alt='filterIcon' /></span></div>
                                {(showFilder) && <div className='select-filter-list'>
                                      <div className='select-filter-listinner'>
                                          <div className='select-filterlist-title'>
                                                  <h5 className='select-filterlist-titletxt'>Filters</h5>
                                                  <span className='select-filterlist-icon' onClick={() => setShowFilder(false)}><i className="bx bx-x"></i></span>
                                          </div>
                                          <div className='select-filterlist-main'>
                                            <div className='select-filterlist-row'>
                                                  <label>Bunk Status</label>
                                                  <Select
                                                    name="planType"
                                                    options={subscriptionStatusOptions}
                                                    value={formData.planType}
                                                    onChange={handleChange}
                                                    placeholder={"Select Plan Type"}
                                                    className='custom-react-sltbx'
                                                    classNamePrefix="custom-react-sltbx"
                                                  />
                                            </div>
                                             <div className='select-filterlist-row'>
                                                  <label>State</label>
                                                  <Select
                                                    name="planType"
                                                    options={subscriptionStatusOptions}
                                                    value={formData.planType}
                                                    onChange={handleChange}
                                                    placeholder={"Select Plan Type"}
                                                    className='custom-react-sltbx'
                                                    classNamePrefix="custom-react-sltbx"
                                                  />
                                            </div>
                                            <div className='select-filterlist-row'>
                                                  <label>District</label>
                                                  <Select
                                                    name="planType"
                                                    options={subscriptionStatusOptions}
                                                    value={formData.planType}
                                                    onChange={handleChange}
                                                    placeholder={"Select Plan Type"}
                                                    className='custom-react-sltbx'
                                                    classNamePrefix="custom-react-sltbx"
                                                  />
                                            </div> 
                                            <div className='select-filterlist-row'>
                                              <label>Area</label>
                                              <Select
                                                name="subscriptionStatus"
                                                options={subscriptionStatusOptions}
                                                onChange={handleChange}
                                                value={formData.subscriptionStatus}
                                                placeholder="Select Subscription Status"
                                                className="select2 custom-react-sltbx"
                                                classNamePrefix="custom-react-sltbx"
                                              />
                                            </div>  
                                          </div>
                                          <div className='d-flex justify-content-center gap-2 select-filterlist-action'>
                                              <Button variant="secondary custom-reset-btncls" type="button">
                                                Reset
                                              </Button>
                                              <Button variant="secondary custom-apply-btncls" type="button">
                                                Apply
                                              </Button>
                                          </div>
                                      </div>
                                </div>}
                            </div>
                        </Col> */}
                        <Col xs={12} sm={6} md={3} className='apply-mgtp-mbl'>
                            <div className='daterangepicker-maincls'>
                              <DateRangePicker onApply={handleDateRangeApply} />
                            </div>
                        </Col>
                    </Row>
              </div>

              <Row>
                <Col xs="12">
                      <div className='tablelist-maindiv'>
                          <ServerTable
                            key={tableKey}
                            apiUrlTxt="vehicle-activities"
                            columns={columns}
                            customParams={searchObjVal}
                            showSearch={false}
                            showAddBtn={false}
                            addBtn={{ label: '', url: `` }}
                            srlNumbr={false}
                            customSearch={true}
                            customSearchTxt={customSearch}
                          />
                      </div>
                
                </Col>
              </Row>
            </div>   
          </Container>
        </div>);
}
